import React from "react"
import { Box, Flex, Link } from "theme-ui"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "templates/layout"
import TopBanner from "components/topBanner"
import ContentBox from "components/content"
import styled from "@emotion/styled"
import Breadcrums from "components/breadcrums"

const PageWrapper = styled.div`
    position: relative;
    color: #ffffff;
    & .caption-box-topbanner {
        text-shadow: #545454 1px 0 10px;
    }
    & .position {
        justify-content: left;
        text-align: left;
    }
    & h2 {
        border-left: ${(props) => props.theme.colors.primary} double;
        border-width: 4px 4px 0 4px;
        box-shadow: -3px 0 0 0 ${(props) => props.theme.colors.primary};
        padding-left: 0.5rem;
        line-height: 0.75;
        margin-left: -1.2rem;
        font-weight: normal;
        margin-bottom: 1rem;
    }
    & .form-wrapper {
        & p {
            margin: 0;
        }
    }
    @media (max-width: ${(props) => props.theme.breakpoints[3]}) {
        & h2 {
            font-size: 27px;
        }
        & p {
            font-size: 15px;
        }
        & .form-wrapper {
            flex-direction: column-reverse;
            & div {
                padding: 0;
            }
        }
    }
`

// markup
const IndexPage = ({ location }) => {
    const data = useStaticQuery(query)

    const { company, pageData } = data

    let contact_form,
        google_map = null
    pageData.content.forEach((page) => {
        if (page.external_script) {
            page.external_script.forEach((ext) => {
                if (ext.name === "contact_form") {
                    contact_form = ext.script
                } else if (ext.name === "google_map") {
                    google_map = ext.script
                }
            })
        }
    })

    const topBarData = {
        title: pageData.title,
        imageFile: pageData.image,
        banner_background_color:
            "linear-gradient(90deg, #e8b7d4 25%, #eabfd9 25%, #eabfd9 50%, #e8b7d4 50%, #e8b7d4 75%, #eabfd9 75%, #eabfd9 100%)",
    }
    const linksBreadcrums = [pageData.menu_title]
    let whatsapp = null
    if (company.whatsapp) {
        whatsapp = company.whatsapp.replace(/ /g, "").replace("+", "")
    }
    return (
        <Layout
            page={pageData}
            metadata={pageData.metadata}
            location={location}
        >
            <PageWrapper>
                <TopBanner data={topBarData} />
                <ContentBox>
                    <Breadcrums links={linksBreadcrums} />
                    <Flex>
                        <Box>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: pageData.description,
                                }}
                            ></div>
                        </Box>
                    </Flex>
                    <Flex className="form-wrapper">
                        <Box sx={{ flex: 1, px: 3 }}>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: contact_form,
                                }}
                            ></div>
                        </Box>
                        <Box sx={{ flex: 1, px: 3 }}>
                            <p>{company.address}</p>
                            <p>
                                Email :{" "}
                                <Link
                                    href={`mailto:${company.email}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {company.email}
                                </Link>
                            </p>
                            <p>
                                Tel :{" "}
                                <Link
                                    href={`tel:${company.tel}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {company.tel}
                                </Link>
                            </p>
                            <p>
                                Whatsapp :{" "}
                                <Link
                                    href={`https://wa.me/${whatsapp}`}
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    {company.whatsapp}
                                </Link>
                            </p>
                            <p>
                                If you are unable to call, please email to us
                                and we will get back to you as soon as possible.
                                Thank you!
                            </p>
                        </Box>
                    </Flex>
                </ContentBox>
                <div dangerouslySetInnerHTML={{ __html: google_map }}></div>
            </PageWrapper>
        </Layout>
    )
}

export default IndexPage

const query = graphql`
    query {
        company: strapiCompany(shortname: { eq: "EIP" }) {
            email
            address
            name
            tel
            whatsapp
        }
        pageData: strapiPage(
            slug: { eq: "contact-us" }
            company: { shortname: { eq: "EIP" } }
        ) {
            title
            menu_title
            description
            image {
                childImageSharp {
                    gatsbyImageData(placeholder: BLURRED)
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            image {
                childImageSharp {
                    resize(width: 1200, height: 630, cropFocus: CENTER) {
                        src
                    }
                }
            }
            content {
                external_script {
                    id
                    name
                    script
                }
                Single_Column {
                    Text_Alignment
                    content
                    id
                    title
                }
                title
            }
        }
    }
`
